import React, { useState } from "react";
import icon from "../../assets/iconEventId.png";
import { toast } from "react-toastify";
import { useGetEventDataById } from "../../hooks/useEvent";
import { EventStatusConstants } from "../../constants/eventStatus";
import { useEventTypeById } from "../../hooks/useEventType";

function Register({ values, setValues, setCurrentStep }) {
  const {
    data: event,
    error,
    isLoading,
  } = useGetEventDataById(values.event_id);
  const { data: eventType, isLoading: eventTypeLoading } = useEventTypeById(
    event?.event_type_id
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!values.event_id.trim()) {
      toast.error("Please Enter the Event ID");
      return;
    }

    // Check if still loading
    if (isLoading || eventTypeLoading) {
      return;
    }

    // Check if there's an error
    if (error) {
      toast.error("Error fetching event data");
      return;
    }

    // Check if event exists (data will be null if event not found)
    if (!event) {
      toast.error("Event ID not found");
      return;
    }

    if (event.status === EventStatusConstants.CLOSED.text) {
      toast.info("This event has been closed");
      return;
    }

    if (event.status === EventStatusConstants.COMPLETED.text) {
      toast.info("This event has been completed");
      return;
    }

    if (!eventType?.allow_app_sign) {
      toast.error("Not Allowed to Sign In to this Event");
      return;
    }

    const currentDate = new Date();
    const eventStartDate = new Date(event.start_date);
    if (currentDate < eventStartDate) {
      toast.error("This event is scheduled for the future");
      return;
    }

    setIsSubmitting(true);
    setValues((prev) => ({
      ...prev,
      event_id: values.event_id.trim(),
    }));

    // Move to the next step (WelcomePage)
    setCurrentStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <div className="container">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 bg-white rounded-lg shadow p-4 mx-5 md:mx-8 lg:mx-0">
        <div className="p-8 m-3 md:border-r-2 border-gray-500">
          <h1 className="font-bold text-2xl my-3">
            Welcome, Please insert the Event ID
          </h1>
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="event-id" className="font-medium text-lg">
                Event ID
              </label>
              <input
                name="event_id"
                type="text"
                value={values?.event_id}
                onChange={handleChange}
                className="w-full border-2 border-purpleColor rounded-lg p-2 my-3"
                placeholder="Enter Event ID"
              />
              <div className="flex justify-end">
                <button
                  data-track="next-event-registration-button"
                  data-module="Register"
                  type="submit"
                  disabled={isLoading || eventTypeLoading || isSubmitting}
                  className="bg-purpleColor text-white w-full md:w-32 lg:w-48 p-2 rounded-lg my-2 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {(isLoading || eventTypeLoading || isSubmitting) && (
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                  )}
                  <span>Next</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="p-8 m-3 flex justify-center">
          <img src={icon} alt="Event Icon" />
        </div>
      </div>
    </div>
  );
}

export default Register;
